import React from 'react';
import { Mail, PhoneCall, MapPin, Instagram } from 'lucide-react';
import { PageHero, SectionTitle, Input, Textarea, Card } from '../components/PageUI';

const ContactPage = () => {
  return (
    <div>
      <PageHero
        eyebrow="Contato"
        title="Fale com a Zartoo."
        subtitle="Solicite demonstração, tire dúvidas ou peça um orçamento personalizado."
        primaryCta={{ label: 'Agendar demo', href: '/demonstracao' }}
      />

      <section className="bg-slate-950">
        <div className="container mx-auto px-8 lg:px-12 py-16 grid lg:grid-cols-[1.1fr_0.9fr] gap-8">
          <div>
            <SectionTitle
              eyebrow="Formulário"
              title="Envie sua mensagem"
              description="Responderemos o mais rápido possível."
            />
            <form className="grid md:grid-cols-2 gap-4">
              <Input label="Nome completo" placeholder="Digite seu nome" />
              <Input label="E-mail" type="email" placeholder="voce@empresa.com" />
              <Input label="Telefone" placeholder="(11) 99999-9999" />
              <Input label="Empresa" placeholder="Nome da empresa" />
              <Input label="Segmento" placeholder="Distribuidora, varejo..." />
              <Input label="Interesse" placeholder="ERP / APP / PDV / Todos" />
              <div className="md:col-span-2">
                <Textarea label="Mensagem" rows={4} placeholder="Conte o contexto" />
              </div>
              <button type="submit" className="md:col-span-2 px-6 py-3 rounded-xl font-black text-lg bg-[#FF6B35] text-white">
                Enviar mensagem
              </button>
            </form>
          </div>

          <div className="space-y-4">
            <Card>
              <h3 className="text-xl font-semibold mb-4">Informações de contato</h3>
              <div className="space-y-3 text-sm text-slate-200/80">
                <div className="flex items-center gap-3">
                  <PhoneCall className="w-5 h-5 text-[#FF6B35]" />
                  <span>(11) 97559-2019 / (11) 99861-0036</span>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-[#FF6B35]" />
                  <span>contato@zartoo.com.br</span>
                </div>
                <div className="flex items-center gap-3">
                  <Instagram className="w-5 h-5 text-[#FF6B35]" />
                  <span>@zartoobrasil</span>
                </div>
                <div className="flex items-center gap-3">
                  <MapPin className="w-5 h-5 text-[#FF6B35]" />
                  <span>Barueri - SP</span>
                </div>
              </div>
            </Card>

            <Card>
              <h3 className="text-xl font-semibold mb-2">Horário de atendimento</h3>
              <p className="text-sm text-slate-200/80">Segunda a Sexta: 8h às 18h</p>
            </Card>

            <Card>
              <h3 className="text-xl font-semibold mb-2">Mapa</h3>
              <div className="aspect-video rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-slate-200/70">
                Google Maps embed
              </div>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
